import { useStoreStock } from '@gozoki/api'
import { includesLowerCase, priceToString } from '@gozoki/tools'
import { Paper, TextField } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo, useState } from 'react'
import { z } from 'zod'
import StockCard from '~/components/communication/StockCard'
import SimpleDataGrid from '~/components/containers/SimpleDataGrid'
import { StoreDetailsLayout } from '~/components/routes/stores/StoreDetailsLayout'
import { stockColDef } from '~/components/routes/stores/stocks/stockGrids'
import { STORE_TAB_PERMISSIONS } from '~/components/routes/stores/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { DataGridOverrides } from '~/utils/theme/overrides.theme'

export const Route = createFileRoute('/_authenticated/stores/$storeId/stocks/')({
  staticData: {
    permission: STORE_TAB_PERMISSIONS.stocks,
  },
  component: StoreStocksTab,
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function StoreStocksTab() {
  const navigate = Route.useNavigate()
  const { storeId } = Route.useParams()

  const [stockSearch, setStockSearch] = useState('')

  const stock = useStoreStock(storeId)

  const stockRows = useMemo(() => {
    if (stock.data === undefined) {
      return []
    }
    return stock.data.rows.filter((row) => includesLowerCase(row.label, stockSearch))
  }, [stock.data, stockSearch])

  return (
    <StoreDetailsLayout storeId={storeId} tab="stocks">
      <div style={{ display: 'flex' }}>
        <StockCard
          mr
          flex
          title="NB D'ARTICLES TOTAL EN STOCK"
          content={stock.data?.metadata.articleCount}
        />
        <StockCard
          mr
          flex
          title="NB D'ARTICLES ANTI GASPI EN STOCK"
          content={stock.data?.metadata.antiGaspiArticleCount}
        />

        <StockCard
          flex
          title="NB D'ARTICLES EXPIRES EN STOCK"
          content={stock.data?.metadata.expiredArticleCount}
        />
      </div>
      <div style={{ padding: 10 }} />
      <div style={{ display: 'flex' }}>
        <StockCard
          mr
          flex
          title="VALORISATION TOTALE DES ARTICLES EN STOCK"
          content={priceToString(stock.data?.metadata.totalStockValue ?? 0)}
        />
        <StockCard
          mr
          flex
          title="VALORISATION DES ARTICLES ANTI GASPI EN STOCK"
          content={priceToString(stock.data?.metadata.totalAntiGaspiStockValue ?? 0)}
        />

        <StockCard
          flex
          title="VALORISATION TOTALE DES ARTICLES EXPIRES EN STOCK"
          content={priceToString(stock.data?.metadata.totalExpiredStockValue ?? 0)}
        />
      </div>
      <Paper
        sx={{
          marginTop: '16px',
        }}
      >
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            padding: '16px',
          }}
        >
          <TextField
            variant="outlined"
            label="Recherche"
            value={stockSearch}
            onChange={(e) => setStockSearch(e.target.value)}
          />
          <div style={{ flexGrow: 1 }} />
        </div>
        <SimpleDataGrid
          columns={stockColDef}
          rows={stockRows}
          loading={stock.isLoading}
          checkboxSelection={false}
          sx={DataGridOverrides.wrapHeaderNames}
          onRowClick={(row) =>
            navigate({
              to: '/stores/$storeId/stocks/product/$productId',
              params: { storeId, productId: row.id as number },
            })
          }
        />
      </Paper>
    </StoreDetailsLayout>
  )
}
